import React from 'react'
import { Centered, StateActions, StateMessage, StateTitle } from './PublicPageState.styles'

/**
 * The transient-failure state for public share pages: server errors and network
 * failures land here, NOT on the unavailable state — "unavailable" asserts
 * owner intent (private / not shared), and a backend outage must never
 * masquerade as that. Copy invites a retry because the failure is retryable.
 */
interface PublicErrorStateProps {
	/** A way out for a visitor who has one, e.g. a link back to their trips. */
	action?: React.ReactNode
}

const PublicErrorState: React.FC<PublicErrorStateProps> = ({ action }) => (
	<Centered>
		<StateTitle>Something went wrong</StateTitle>
		<StateMessage>We couldn&apos;t load this page. Please try again in a moment.</StateMessage>
		{action && <StateActions>{action}</StateActions>}
	</Centered>
)

export default PublicErrorState
